<template>
  <div class="performanceListBox">
    <div class="performanceListMain">
      <breadcrumb>
        <el-breadcrumb slot="breadcrumb" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>履约列表</el-breadcrumb-item>
        </el-breadcrumb>
      </breadcrumb>
      <div class="performanceListCon">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="履约中" name="first">
            <perdoing></perdoing>
          </el-tab-pane>
          <el-tab-pane label="已完成" name="second">
            <perfinsh></perfinsh>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import perdoing from "./components/performanceList/performanceDoing.vue";
import perfinsh from "./components/performanceList/performanceFinsh.vue";
import Breadcrumb from "@common/Breadcrumb.vue";
export default {
  data() {
    return {
      activeName: "first"
    };
  },
  mounted() {},
  methods: {
  },
  components: {
    perdoing,
    perfinsh,
    Breadcrumb
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.performanceListBox {
  background: #eaedf1;
  width: 100%;
  box-sizing: border-box;
  overflow: scroll;
  .performanceListMain {
    width: 100%;
    height: 100%;
    display: table;
    background: #fff;
    border-radius: 3px;
    padding: 20px;
    box-sizing: border-box;
    .performanceListHead {
      width: 100%;
      height: 36px;
      padding: 8px 0;
      box-sizing: border-box;
      box-shadow: inset 0 -1px 0 0 rgba(230, 230, 230, 0.5);
      li {
        float: left;
      }
      li:nth-child(1) {
        display: block;
        width: 4px;
        height: 20px;
        background: #e88078;
        margin-right: 20px;
        border-radius: 4px;
      }
      li:nth-child(2) {
        // color:#787878;
        font-family: "PingFangSC-Medium";
      }
      li:last-child {
        color: #e88078;
      }
    }
    .performanceListCon {
      width: 100%;
      margin-top: 30px;
      .el-tabs__header {
        line-height: 36px;
        margin-bottom: 0;
        border: 0;
        .el-tabs__nav {
          border: 0;
        }
        .el-tabs__item {
          background: #f5f5f5;
          border: 1px solid #e4e7ed;
          width: 120px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          font-size: 12px;
          color: #646464;
          border-bottom: 0;
        }
        .el-tabs__item.is-active {
          background-color: #fff;
          color: #e88078;
          border-top: 2px solid #e88078;
          height: 34px;
          line-height: 34px;
        }
        .el-tabs__item:nth-child(2) {
          border-left: 0;
        }
      }
      .el-tabs__content {
        border: 1px solid #e4e8eb;
        padding: 20px;
      }
    }
  }
}
.cellCustomer {
  height: 32px;
  text-align: center;
  line-height: 32px;
  padding: 0;
  color: #969696;
}
.headerCellCustomer {
  color: #505050;
  background-color: #f9f9f9;
}
</style>
